import type { ReactNode } from "react";

/** Show all actions directly up to this count; above it, keep the first two + More. */
export const MAX_DIRECT_ACTIONS = 3;
export const DIRECT_ACTIONS_WHEN_OVERFLOW = 2;

/** Latches AG Grid hover paint while the portaled More menu is open. */
export const ORDERED_ROW_MENU_OPEN_CLASS = "row-ordered-actions-menu-open";

export type OrderedRowActionKey = "edit" | "phlebotomy" | "shipKit" | "print";

export type OrderedRowAction = {
  key: OrderedRowActionKey;
  label: string;
  disabled: boolean;
  icon: ReactNode;
  onSelect: () => void | Promise<void>;
  keepFocusWhenDisabled?: boolean;
  tooltipBackgroundColor?: string;
};

export const partitionOrderedRowActions = <T>(
  actions: T[],
): {
  directActions: T[];
  overflowActions: T[];
  hasOverflow: boolean;
} => {
  if (actions.length <= MAX_DIRECT_ACTIONS) {
    return {
      directActions: actions,
      overflowActions: [],
      hasOverflow: false,
    };
  }

  return {
    directActions: actions.slice(0, DIRECT_ACTIONS_WHEN_OVERFLOW),
    overflowActions: actions.slice(DIRECT_ACTIONS_WHEN_OVERFLOW),
    hasOverflow: true,
  };
};
